/**
 * @generated SignedSource<<c50a6c4dd7aee6db59a0135c1e382ecf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InsightMetricFilterField = "KpiAbsent" | "KpiPresent" | "LabelLift" | "NumberOfAdsAbsent" | "NumberOfAdsPresent" | "SpendAbsent" | "SpendPresent" | "%future added value";
export type InsightV2OrderBy = "AD_SPEND_ABSENT_ASC" | "AD_SPEND_ABSENT_DESC" | "AD_SPEND_PRESENT_ASC" | "AD_SPEND_PRESENT_DESC" | "COUNT_ABSENT_ASC" | "COUNT_ABSENT_DESC" | "COUNT_PRESENT_ASC" | "COUNT_PRESENT_DESC" | "DELTA_ASC" | "DELTA_DESC" | "LABEL_LIFT_ASC" | "LABEL_LIFT_DESC" | "LABEL_NAME_ASC" | "LABEL_NAME_DESC" | "LABEL_TYPE_ASC" | "LABEL_TYPE_DESC" | "RATE_WHEN_ABSENT_ASC" | "RATE_WHEN_ABSENT_DESC" | "RATE_WHEN_PRESENT_ASC" | "RATE_WHEN_PRESENT_DESC" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListInsightV2Request = {
  filter: InsightV2Filter;
  orderBy?: InsightV2OrderBy | null;
  pagination?: PaginationInput | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type InsightV2Filter = {
  brandId: string;
  delta_gt?: number | null;
  delta_lt?: number | null;
  includeAllDates?: boolean | null;
  kpi: KPI;
  labelTypes: ReadonlyArray<LabelType>;
  metrics?: ReadonlyArray<InsightMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type InsightMetricFilter = {
  fieldKey: InsightMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type InsightsTableExportCSVQuery$variables = {
  input: ListInsightV2Request;
};
export type InsightsTableExportCSVQuery$data = {
  readonly exportCSV: {
    readonly csvData: string;
  };
};
export type InsightsTableExportCSVQuery = {
  response: InsightsTableExportCSVQuery$data;
  variables: InsightsTableExportCSVQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CSVExportResponse",
    "kind": "LinkedField",
    "name": "exportCSV",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "csvData",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InsightsTableExportCSVQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InsightsTableExportCSVQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9858a5e3803413d465942b088e459a30",
    "id": null,
    "metadata": {},
    "name": "InsightsTableExportCSVQuery",
    "operationKind": "query",
    "text": "query InsightsTableExportCSVQuery(\n  $input: ListInsightV2Request!\n) {\n  exportCSV(input: $input) {\n    csvData\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2c95c9d5e799fc91d401e6575461214";

export default node;
